<template>
  <router-view />
</template>

<script setup>
import { useMiscStore } from '@/stores/misc';

const store = useMiscStore();
store.fetchSectors();
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kablammo:MORF@60&display=swap');
#app {
  font-family: Roboto, Avenir, Helvetica, Arial, system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  letter-spacing: 0.05rem;
}
</style>
